export default __webpack_public_path__ + "static/media/strawberry.1d266aaa.svg";